import { render, staticRenderFns } from "./editPhoneDialog.vue?vue&type=template&id=989e647c&scoped=true&"
import script from "./editPhoneDialog.vue?vue&type=script&lang=js&"
export * from "./editPhoneDialog.vue?vue&type=script&lang=js&"
import style0 from "./editPhoneDialog.vue?vue&type=style&index=0&id=989e647c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989e647c",
  null
  
)

export default component.exports